import { ComponentProps } from 'react';

import { cn } from '@/utils/tailwind';

const Skeleton = ({ className, ...props }: ComponentProps<'div'>) => {
  return (
    <div
      data-slot="skeleton"
      className={cn('bg-custom-warm-grey-150 animate-pulse rounded-[4px]', className)}
      {...props}
    />
  );
};

export { Skeleton };
